import { useEffect, useState } from "react";
import type { Client } from "../types";
import { SearchOverlay } from "./ProjectDiscovery";
import { overlayThemeVariables } from "../overlayTheme";

export default function SearchFrame() {
  const [filteredClients, setFilteredClients] = useState<Client[]>([]);
  const [overlayActionBackgroundColor, setOverlayActionBackgroundColor] = useState("#f7f5ef");

  useEffect(() => {
    const receiveMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === "SHOWROOM_SEARCH_OPEN") {
        setFilteredClients(event.data.filteredClients || []);
        setOverlayActionBackgroundColor(event.data.overlayActionBackgroundColor || "#f7f5ef");
      }
      if (event.data?.type === "SHOWROOM_SEARCH_CLEAR") {
        setFilteredClients([]);
      }
    };
    window.addEventListener("message", receiveMessage);
    window.parent.postMessage({ type: "SHOWROOM_SEARCH_READY" }, window.location.origin);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);

  return <main className="search-frame-page" style={overlayThemeVariables(overlayActionBackgroundColor)}
    onPointerDown={() => window.parent.postMessage({ type: "SHOWROOM_SEARCH_ACTIVITY" }, window.location.origin)}>
    <SearchOverlay
      filteredClients={filteredClients}
      onSelect={(client) => window.parent.postMessage({ type: "SHOWROOM_SEARCH_SELECT", clientId: client.id }, window.location.origin)}
      onClose={() => window.parent.postMessage({ type: "SHOWROOM_SEARCH_CLOSE" }, window.location.origin)} />
  </main>;
}
